module.exports = __webpack_public_path__ + "img/report-10.a075c1d0.jpeg";